<i [class]="getType() + ' fa-' + this.name + ' ' + getSize()"></i>
